/**
 * File input props for harvest-proof photo capture.
 *
 * Always use capture="environment" so mobile opens the camera directly (no gallery).
 * Combined with a transparent overlay on the button — required on Android Chrome
 * where hidden inputs + programmatic .click() are blocked.
 */
export function getHarvestProofPhotoInputProps(): {
  accept: string;
  capture: 'environment';
} {
  return { accept: 'image/*', capture: 'environment' };
}

/** Reject gallery picks: camera captures have a very recent lastModified. */
export function isLikelyLiveCameraCapture(file: File, maxAgeMs = 3 * 60 * 1000): boolean {
  if (!file.lastModified) {
    return true;
  }
  return Date.now() - file.lastModified <= maxAgeMs;
}
